import { createRefPath, createRefPath_client, createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from "lodash";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { PapsContext } from "../PapsContext";
import { _showAppLogs, LogContext } from "../LogContext";

export const useFirestore = ({ items, forClient = false, forBase = false, returnFirstObject }) => {

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext;
  const { pathViews } = paps_state ?? {};

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const [currentData, setCurrentData] = useState();
  const docName = items ? _.join(_.filter(items), '_') : 'None';

  // Ref to ensure we only set up listener once
  const listenerSet = useRef(false);

  useEffect(() => {
    if (!items || !database_fns || listenerSet.current) return;

    let refPath;
    if (forBase) {
      refPath = createRefPath(items);
    } else if (forClient) {
      refPath = createRefPath_client(pathViews, items);
    } else {
      refPath = createRefPath_event(pathViews, items);
    }

    const cb = (fetchedData) => {
      _showAppLogs.dbFetch && log_handlers.addLog(`🌐💾 Fetched data(${docName}) from Firebase`);
      setCurrentData(fetchedData);
    };

    try {
      database_fns.get_data({
        refPath,
        callback: cb,
        opts: { listen: true, returnFirstObject },
      });
      listenerSet.current = true; // mark that listener is set
    } catch (err) {
      console.error(`❌ Failed to fetch data-${docName}:`, err);
    }

    // Cleanup: optional if your database_fns.get_data returns an unsubscribe function
    return () => {
      // If your get_data returns an unsubscribe function:
      // unsubscribe?.();
    };

  }, [forBase, forClient, pathViews, docName]);

  const updateClientProfiles = useCallback(
    async (clientProfiles, merge, remove) => {
      if (remove) {
        return removeClientProfiles(database_fns, clientProfiles, pathViews)
      } else {
        return updateClient_profiles(database_fns, clientProfiles, pathViews, merge);
      }
    },
    []
  );

  return {
    data: currentData,
  };
};
